/**
 * Canonical lists for Spanish address UI (applicant flow + advisor case edit).
 * `value` = stored in Mongo / collected_fields (Spanish official). `label` = same for display.
 */

/** Provinces: official Spanish name for both value and label. */
export const SPAIN_PROVINCE_OPTIONS = [
  { value: 'Álava', label: 'Álava' },
  { value: 'Albacete', label: 'Albacete' },
  { value: 'Alicante', label: 'Alicante' },
  { value: 'Almería', label: 'Almería' },
  { value: 'Asturias', label: 'Asturias' },
  { value: 'Ávila', label: 'Ávila' },
  { value: 'Badajoz', label: 'Badajoz' },
  { value: 'Barcelona', label: 'Barcelona' },
  { value: 'Burgos', label: 'Burgos' },
  { value: 'Cáceres', label: 'Cáceres' },
  { value: 'Cádiz', label: 'Cádiz' },
  { value: 'Cantabria', label: 'Cantabria' },
  { value: 'Castellón', label: 'Castellón' },
  { value: 'Ciudad Real', label: 'Ciudad Real' },
  { value: 'Córdoba', label: 'Córdoba' },
  { value: 'Cuenca', label: 'Cuenca' },
  { value: 'Gerona', label: 'Gerona' },
  { value: 'Granada', label: 'Granada' },
  { value: 'Guadalajara', label: 'Guadalajara' },
  { value: 'Guipúzcoa', label: 'Guipúzcoa' },
  { value: 'Huelva', label: 'Huelva' },
  { value: 'Huesca', label: 'Huesca' },
  { value: 'Islas Baleares', label: 'Islas Baleares' },
  { value: 'Jaén', label: 'Jaén' },
  { value: 'La Coruña', label: 'La Coruña' },
  { value: 'La Rioja', label: 'La Rioja' },
  { value: 'Las Palmas', label: 'Las Palmas' },
  { value: 'León', label: 'León' },
  { value: 'Lérida', label: 'Lérida' },
  { value: 'Lugo', label: 'Lugo' },
  { value: 'Madrid', label: 'Madrid' },
  { value: 'Málaga', label: 'Málaga' },
  { value: 'Murcia', label: 'Murcia' },
  { value: 'Navarra', label: 'Navarra' },
  { value: 'Orense', label: 'Orense' },
  { value: 'Palencia', label: 'Palencia' },
  { value: 'Pontevedra', label: 'Pontevedra' },
  { value: 'Salamanca', label: 'Salamanca' },
  { value: 'Santa Cruz de Tenerife', label: 'Santa Cruz de Tenerife' },
  { value: 'Segovia', label: 'Segovia' },
  { value: 'Sevilla', label: 'Sevilla' },
  { value: 'Soria', label: 'Soria' },
  { value: 'Tarragona', label: 'Tarragona' },
  { value: 'Teruel', label: 'Teruel' },
  { value: 'Toledo', label: 'Toledo' },
  { value: 'Valencia', label: 'Valencia' },
  { value: 'Valladolid', label: 'Valladolid' },
  { value: 'Vizcaya', label: 'Vizcaya' },
  { value: 'Zamora', label: 'Zamora' },
  { value: 'Zaragoza', label: 'Zaragoza' },
];

export const SPAIN_ADDRESS_DOOR_OPTIONS = [
  ...'ABCDEFGHIJKLMNOPQRSTUVWXYZ'.split('').map((letter) => ({ value: letter, label: letter })),
  { value: 'Izq', label: 'Izq' },
  { value: 'Dcha', label: 'Dcha' },
];

/** Stored province strings only (for validation / backwards compatibility). */
export const SPAIN_PROVINCES = SPAIN_PROVINCE_OPTIONS.map((o) => o.value);

/**
 * Piso (floor): `value` stored (unchanged for API/Mongo); `label` = compact Spanish for the UI.
 */
export const SPAIN_ADDRESS_FLOOR_OPTIONS = [
  { value: 'Bajo', label: 'Bajo' },
  { value: 'Entresuelo', label: 'Ent.' },
  ...Array.from({ length: 15 }, (_, i) => {
    const n = i + 1;
    return { value: String(n), label: `${n}º` };
  }),
  { value: 'Atico', label: 'Ático' },
];
